// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { iPadProResolution } from "Content/Shared/Styles/Theme"
import ReactIcon from "Assets/Images/Icons/technologies/react.svg"
import SwiftIcon from "Assets/Images/Icons/technologies/swift.svg"

// REDUX
import { ExpositionType } from "Redux/Types/ExpositionsTypes"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  exposition: ExpositionType
  isRight: boolean
}

const Body: React.FC<PropsType> = (props) => {
  const { title, tech } = props.exposition

  const Techs = {
    ReactNative: {
      title: "React Native (iOS & Android)",
      image: ReactIcon,
    },
    Swift: {
      title: "Swift (iOS)",
      image: SwiftIcon,
    },
  } as any

  const technology = Techs[tech]
  return (
    <Wrapper isRight={props.isRight}>
      <TitleWrap isRight={props.isRight}>
        <Title isRight={props.isRight}>{title}</Title>
        <img src={technology.image} />
      </TitleWrap>
      <TechText>
        <BoldText>Made with:</BoldText> {technology.title}
      </TechText>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const CONTENT_HORIZONTAL = 30
const HORIZONTAL_MARGIN = 12
const Wrapper = styled.div`
  text-align: left;

  @media (min-width: ${1120}px) {
    margin: ${({ isRight }: { isRight: boolean }) =>
      `0px ${isRight ? CONTENT_HORIZONTAL : 0}px 0px ${
        isRight ? 0 : CONTENT_HORIZONTAL
      }px`};
  }

  @media (max-width: ${iPadProResolution}px) {
    margin-left: 50px;
  }
`

const TitleWrap = styled.div`
  display: flex;
  @media (min-width: ${1120}px) {
    flex-direction: ${({ isRight }: { isRight: boolean }) =>
      isRight ? "row-reverse" : "row"};
  }

  img {
    height: 40px;

    @media (max-width: ${iPadProResolution}px) {
      height: 36px;
    }
  }
`

const Title = styled.div`
  font-size: 32px;
  @media (min-width: ${1120}px) {
    margin: ${({ isRight }: { isRight: boolean }) =>
      `0px ${isRight ? 0 : HORIZONTAL_MARGIN}px 0px ${
        isRight ? HORIZONTAL_MARGIN : 0
      }px`};
  }

  @media (max-width: ${iPadProResolution}px) {
    font-size: 26px;
    margin-right: 20px;
  }
`

const TechText = styled.span`
  letter-spacing: 1px;
`

const BoldText = styled.span`
  font-weight: bold;
  margin-right: 4px;
`

export default React.memo(Body, memoComparison)
